// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"49":"join","51":"api-reference","286":"commands","364":"npcloot","473":"trade","641":"travel"}[chunkId] || chunkId) + "." + {"49":"cf2719eb","51":"61dff7ad","247":"09a5719d","286":"97106ad9","364":"ea954e8e","473":"ae605f64","641":"8482733f"}[chunkId] + ".js";
};